import { createAction, props } from '@ngrx/store';
import { Producer } from 'src/app/shared/models/producer.model';

export const loadProducers = createAction(
  '[Producer Component] Load Producers'
);

export const loadProducersSuccess = createAction(
  '[Producer Component] Load Producers Success',
  props<{ data: Producer[] }>()
);

export const loadProducersFailure = createAction(
  '[Producer Component] Load Producers Failure',
  props<{ error: any }>()
);

export const loadProducerDetail = createAction(
  '[Producer Component] Load Producers Detail',
  props<{ id: string }>()
);

export const loadProducerDetailSuccess = createAction(
  '[Producer Component] Load Producers Detail Success',
  props<{ data: Producer }>()
);

export const loadProducerDetailFailure = createAction(
  '[Producer Component] Load Producers Detail Failure',
  props<{ error: any }>()
);

export const setProducerFilter = createAction(
  '[Producer Component] Set producer filters',
  props<{ filter?: string, hasAccount?: boolean, hasUser?: boolean }>()
);

export const setProducerCurrentPage = createAction(
  '[Producer Component] Set producer curent page',
  props<{ currentPage: number }>()
);
